import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="#6ec3fa" d="M13.182 23.548l-10.617-9.18-1.385 1.6 13.03 11.27 14.31-11.524-1.328-1.65L15.3 23.64V0h-2.118v23.548zM0 36v-2.118h29.647V36H0z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/download.svg